/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\CategorySVG\SUV.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday March 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday March 13th 2023 2:18:06 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from "Content/SVG/SVGProps";

function SUV(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} height={props.height} width={props.width} stroke={props.stroke} strokeWidth={props.strokeWidth} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M919.87,442.93h-40.76c-1.36,0-2.6,.51-3.62,1.34v-53.98c17.66,.47,15.06-40.44,15.06-40.44l-32.42-1.11c-.62-.11-.98-.11-.98-.11H441.58c-3.49,0-8.59,2.45-12.83,7.59h-.06s-19.74,9.1-19.74,9.1l14.47-.17-45.14,99.62,.97,1.1h0l-.97-1.1-178.64,16.87c-9.8,2.4-18.6,6.73-23.88,14.81-1.42,2.17-2.82,4.36-4.19,6.58-.22,.36-.45,.69-.69,1.03h1.98c-.43,.68-.87,1.34-1.29,2.03-.43,.7-.9,1.36-1.36,2.04v.36c-5.85,3.07-10.17,13.37-10.17,25.69,0,10.04,2.89,18.72,7.12,23.27v61.08h-13.14v44.62h61.19v-.6h17.63c.11,17.47,6.75,34.91,20.02,48.31,26.92,27.19,70.8,27.41,97.99,.49,13.57-13.44,20.42-31.09,20.53-48.79h10.28v2.88h277.29v-2.88h16.05c.11,17.47,6.75,34.91,20.02,48.31,26.92,27.19,70.8,27.41,97.99,.49,13.57-13.44,20.42-31.09,20.53-48.79h9.57v.6h65.7v-27.39h-13.32v-50.49l1.41,.04v-4.39c.69,.29,1.43,.47,2.21,.47h40.76c3.38,0,6.12-3.05,6.12-6.81v-124.83c0-3.76-2.74-6.81-6.12-6.81Z"/>
        </svg>
    );
}

export default SUV;
